module.exports = __webpack_public_path__ + "static/media/IMG_9506.1cf59a06.JPG";